import { defineComponent as _defineComponent } from 'vue'
import { watchEffect } from "vue";
import ballLoad from "@/assets/images/ballLoad.gif";

const __default__ = {
  name: "Loading",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  loading: Boolean,
},
  setup(__props, { expose }) {
  expose();

const props = __props


watchEffect(() => {
  if (props.loading) {
    document
      .getElementsByTagName("body")[0]
      .style.setProperty("--hideden", "hidden");
  }else{
    document
      .getElementsByTagName("body")[0]
      .style.setProperty("--hideden", "auto");
  }
});

const __returned__ = { props, ballLoad }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})